import { getImmutableCompatible } from 'src/utils/immutableUtils';
import { FLIGHT_CLASSES } from '../../CheckoutRoutes/PackageCheckout/store/flights/constants';

const getView = (state) => state.get('view');
export const getIsExpanded = (state) => getView(state).get('isMapExpanded');
export const getFlightClass = (state) =>
  getView(state).get('selectedClass') || FLIGHT_CLASSES.ECONOMY;
export const getIsWhitelabel = (state) => getView(state).get('isWhitelabel');
export const getIsWebGlSupported = (state) =>
  getView(state).get('isWebGlSupported');

export const getIsRouteTransition = (state) =>
  getView(state).get('isRouteTransition');

export const getActiveTouristFormIdx = (state) =>
  getView(state).get('activeTouristForm');
const getIsTouristFormActive = (state, id) =>
  getActiveTouristFormIdx(state) === id;
export const makeGetIsTouristFormActive = () => getIsTouristFormActive;
export const getIsTopbarExpanded = (state) =>
  getView(state).get('isTopbarExpanded');
export const getTopbarIndex = (state) => getView(state).get('topbarIndex');
export const getScrollPosition = (state) =>
  getView(state).get('scrollPosition');

export const getShowFiltersModal = (state) =>
  getView(state).get('showFiltersModal');

export const getIsFlightsProgressBarSticky = (state): boolean =>
  getView(state).get('flightsProgressBarIsSticky');

export const getShowSummary = (state): boolean =>
  getImmutableCompatible(getView(state), 'showSummary') || false;
